import React, { useState } from "react";
import IconInput from "../../../../styled-components/input/icon-input";
import { Button } from "../../../../styled-components/button";
import { Text } from "../../../../styled-components/text";
import AddModal from "../../../../styled-components/modal/add-modal/add-modal";
import UpdateModal from "../../../../styled-components/modal/update-modal/update-modal";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import * as Style from "./styles/monte-carlo";
import UserDefined from "../user-defined/user-defined";
import { Input } from "../../../../styled-components/input/styles/input";
import StyledRow from "../../../../styled-components/styled-row/styled-row";
import { TextArea } from "../../../../styled-components/text-area";
import { PlusOutlined } from "@ant-design/icons";
import UserDefinedRow from "../user-defined/components/UserDefinedRow";

function MonteCarlo({ handleRatesOfReturnObject, nextForm, preForm }) {
  const monteCarloObj = {
    Description: "",
    "How Many Years": "",
    "High Band": "",
    "Low Band": "",
    "Expected Average": "",
    "Start Year": "",
    Average: "",
  };

  const [monteCarloData, setMonteCarloData] = useState({ ...monteCarloObj });
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [dataList, setDataList] = useState([
    {
      Description: "sample",
      "How Many Years": "15",
      "High Band": "8",
      "Low Band": "6",
      "Expected Average": "80",
      "Start Year": "2019",
      Average: "85",
    },
    {
      Description: "sample1",
      "How Many Years": "15",
      "High Band": "9",
      "Low Band": "6",
      "Expected Average": "85",
      "Start Year": "2019",
      Average: "90",
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState();
  const [updatedObject, setUpdateObject] = useState({
    Description: "",
    "How Many Years": "",
    "High Band": "",
    "Low Band": "",
    "Expected Average": "",
    "Start Year": "",
    Average: "",
  });

  const { styles } = defaultStyles;

  const handleMonteCarloInfo = (obj) => {
    const { name, value } = obj;

    setMonteCarloData({
      ...monteCarloData,
      [name]: value,
    });
  };

  const handleMonteCarloUpdatedInfo = (obj) => {
    const { name, value } = obj;

    setUpdateObject({
      ...updatedObject,
      [name]: value,
    });
  };

  const preComponent = {
    name: "userDefined",
    title: "User Defined",
    isMulti: false,
    component: UserDefined,
  };

  const submitData = () => {
    dataList.push({ ...monteCarloData });

    handleRatesOfReturnObject(dataList);
  };

  const getSelectedRow = (idx) => {
    setShowUpdateModal(true);

    setSelectedIndex(idx);

    // get selected row (this will return array of object)
    const selectedRow = dataList.filter((row, index) => {
      return index == idx;
    });

    setUpdateObject(selectedRow[0]);
  };

  const updateRow = () => {
    dataList[selectedIndex] = updatedObject;
    handleRatesOfReturnObject(dataList);
  };

  const deleteRow = (index) => {
    let newArray = [];
    for (let i = 0; i < dataList.length; i++) {
      if (i == index) {
      } else {
        newArray.push(dataList[i]);
      }
    }

    setDataList(newArray);
    handleRatesOfReturnObject(newArray);
  };

  const handelCloseModal = () => {
    setShowModal(false);
    setShowUpdateModal(false);
  };
  const runMonteCarlo = () => {
    const years = parseInt(monteCarloObj["How Many Years"], 10);
    const startYear = parseInt(monteCarloObj["Start Year"], 10);

    if (!years || !startYear) {
      alert("Please enter valid values for 'How Many Years' and 'Start Year'");
      return;
    }

    const simulations = 1000; // Number of simulations
    const yearlyResults = Array.from({ length: years }, () => []); // Store results for each year

    for (let i = 0; i < simulations; i++) {
      let currentValue = 1000; // Initial investment (can be an input field)
      for (let j = 0; j < years; j++) {
        const randomGrowth = 1 + (Math.random() * 2 - 1) * 0.2; // Random growth between -20% and +20%
        currentValue *= randomGrowth;
        yearlyResults[j].push(currentValue);
      }
    }

      // Calculate average percentage growth for each year
  const growthPercentages = yearlyResults.map((yearValues, idx) => {
    const totalValue = yearValues.reduce((a, b) => a + b, 0);
    const averageValue = totalValue / yearValues.length;

    if (idx === 0) {
      return { year: startYear, growth: 0 }; // No growth for the first year
    }

    const previousYearValues = yearlyResults[idx - 1];
    const totalPreviousValue = previousYearValues.reduce((a, b) => a + b, 0);
    const averagePreviousValue = totalPreviousValue / previousYearValues.length;

    const growthPercentage =
      averagePreviousValue !== 0
        ? ((averageValue - averagePreviousValue) / averagePreviousValue) * 100
        : 0;

    return { year: startYear + idx, growth: (growthPercentage*100).toFixed(2) };
  });
    console.log("growthPercentages",growthPercentages,yearlyResults)

    // setYearlyGrowthPercentages(growthPercentages);

    // Update overall stats
    const allValues = yearlyResults.flat();
    const highBand = Math.max(...allValues);
    const lowBand = Math.min(...allValues);
    const overallAverage = allValues.reduce((a, b) => a + b, 0) / allValues.length;

    // setMonteCarloObj((prev) => ({
    //   ...prev,
    //   Average: overallAverage.toFixed(2),
    //   "High Band": highBand.toFixed(2),
    //   "Low Band": lowBand.toFixed(2),
    //   "Expected Average": ((highBand + lowBand) / 2).toFixed(2),
    // }));
  };

  const fields = [
    {
      Component: Input,
      name: "How Many Years",
      title: "How Many Years",
      type: "text",
      onChange: (event) => handleMonteCarloInfo(event.target),
    },
    {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "High Band",
        title: "High Band",
        icon: "%",
        iconPosition: "end",
        onChange: (event) => handleMonteCarloInfo(event.target),
      },
    },
    {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "Low Band",
        title: "Low Band",
        icon: "%",
        iconPosition: "end",
        onChange: (event) => handleMonteCarloInfo(event.target),
      },
    },
    {
      Component: Input,
      name: "Expected Average",
      title: "Expected Average",
      type: "text",
      onChange: (event) => handleMonteCarloInfo(event.target),
    },
    {
      Component: Input,
      name: "Average",
      title: "Average",
      type: "text",
      onChange: (event) => handleMonteCarloInfo(event.target),
    },
    {
      Component: TextArea,
      style: styles.textArea.modalLargeTextArea,
      name: "Description",
      title: "Description",
      type: "text",
      onChange: (event) => handleMonteCarloInfo(event.target),
    },
  ];

  const update_fields = [
    {
      Component: Input,
      name: "How Many Years",
      title: "How Many Years",
      value: updatedObject["How Many Years"],
      type: "text",
      onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
    },
    {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "High Band",
        title: "High Band",
        icon: "%",
        value: updatedObject["High Band"],
        iconPosition: "end",
        onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
      },
    },
    {
      Component: IconInput,
      value: {
        style: styles.textInput.smallTextInput,
        name: "Low Band",
        title: "Low Band",
        icon: "%",
        value: updatedObject["Low Band"],
        iconPosition: "end",
        onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
      },
    },
    {
      Component: Input,
      name: "Expected Average",
      title: "Expected Average",
      value: updatedObject["Expected Average"],
      type: "text",
      onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
    },
    {
      Component: Input,
      name: "Average",
      title: "Average",
      value: updatedObject["Average"],
      type: "text",
      onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
    },
    {
      Component: TextArea,
      style: styles.textArea.modalLargeTextArea,
      name: "Description",
      value: updatedObject["Description"],
      title: "Description",
      type: "text",
      onChange: (event) => handleMonteCarloUpdatedInfo(event.target),
    },
  ];

  return (
    <>
      <Style.MainContainer>
        <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
          Monte Carlo Rate of Return
        </h3>
        <Style.FieldsContainer>
          <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "24px" }}>
            Add Monte Carlo
          </h3>
          <Button
            style={styles.button.sqaureButton}
            onClick={() => {
              setShowModal(true);
              // runMonteCarlo();
            }}
          >
            <PlusOutlined style={{ color: "#ffffff" }} />
          </Button>
        </Style.FieldsContainer>

        <div
          style={{
            width: "70%",
            rowGap: "2rem",
            display: "flex",
            flexDirection: "column",
            marginTop: "2rem",
          }}
        >
          {dataList && dataList.length > 0 && (
            <UserDefinedRow
              // key={index}
              // item={item}
              getSelectedRow={getSelectedRow}
              deleteRow={deleteRow}
              allItems={dataList}
              // index={index}
            />
          )}
        </div>
        <Style.ButtonsContainer>
          <Button onClick={() => preForm(preComponent)}>Previous</Button>
          <Button
            onClick={() => {
              handleRatesOfReturnObject(dataList);
            }}
          >
            Submit
          </Button>
        </Style.ButtonsContainer>
      </Style.MainContainer>
      <AddModal
        show={showModal}
        close={handelCloseModal}
        fields={fields}
        modalTitle="Add New Monte Carlo"
        handleTaxCreditInfo={handleMonteCarloInfo}
        submitData={submitData}
      />
      <UpdateModal
        show={showUpdateModal}
        close={handelCloseModal}
        modalTitle="Update Monte carlo"
        fields={update_fields}
        updateRow={updateRow}
      />
    </>
  );
}

export default MonteCarlo;
